import { render } from "./bp12ldDirection.vue?vue&type=template&id=6366a90e&scoped=true"
import script from "./bp12ldDirection.vue?vue&type=script&lang=js"
export * from "./bp12ldDirection.vue?vue&type=script&lang=js"

import "./bp12ldDirection.vue?vue&type=style&index=0&id=6366a90e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6366a90e"]])

export default __exports__